var map = {
	"./ar.js": 2043,
	"./bn.js": 1524,
	"./fr.js": 3364,
	"./hi.js": 111,
	"./ms.js": 1648,
	"./ru.js": 2725,
	"./tr.js": 9606,
	"./ur.js": 2607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4379;